import { colors } from '../../styles/theme';
import GuideLayout, { GuideStep } from './GuideLayout';

// Çekici talebi oluşturma adımları (8 adım)
const cekiciSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın. Giriş yapın veya yeni hesap oluşturun.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'Çekici Seçin', description: 'Ana ekranda "Çekici" hizmetine tıklayın. 15dk yanıt, 7/24 hizmet.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Konum Girin', description: 'Alış ve teslim noktalarını girin. Mesafe otomatik hesaplanır.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Araç Tipi Seçin', description: 'Araç tipinizi seçin: Araba, Motosiklet, SUV, Ticari veya TIR.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyatı Görün', description: 'Haritada rota ve toplam ücret görüntülenir. Devam Et ile onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Eşleşme Bekleyin', description: 'Talebiniz gönderildi! Yakındaki sürücüler talebinizi görüyor.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'VISA, MasterCard veya Troy ile güvenli ödeme yapın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Sürücüyü Takip', description: 'Sürücünüzü haritada canlı takip edin. Tahmini varış süresini görün.', image: '/images/customer-app/8.png' },
];

export default function CekiciGuidePage() {
  return (
    <GuideLayout
      service="cekici"
      poster={{ src: '/images/services/cekici.jpg', alt: 'Çekici hizmeti tanıtımı' }}
      seo={{
        title: 'Çekici Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO uygulamasından çekici talebi nasıl oluşturulur? 8 kolay adımda çekici çağırın.',
        keywords: ['çekici talebi', 'çekici çağırma', 'araç kurtarma', 'yolda kaldım'],
      }}
      breadcrumb="Çekici"
      title="Çekici Talebi Nasıl Oluşturulur?"
      subtitle="8 kolay adımda çekici hizmeti alın. Aracınız yolda kaldığında yanınızdayız!"
      accent={{
        from: colors.primary[600],
        to: colors.primary[800],
        soft: colors.primary[50],
        border: colors.primary[200],
        strong: colors.primary[700],
        text: colors.primary[900],
      }}
      steps={cekiciSteps}
      tipsTitle="Çekici Hizmeti İpuçları"
      tips={[
        'Aracınızın yolda mı yoksa yol dışında mı olduğunu doğru işaretleyin, fiyat buna göre değişebilir.',
        'Tavan bagajı, bisiklet taşıyıcısı veya römork varsa mutlaka belirtin.',
        'Konum paylaşımını açık tutun, sürücünüz sizi daha kolay bulsun.',
        'Acil durumlar için 7/24 destek hattımızı arayabilirsiniz.',
      ]}
      cta={{
        title: 'Hemen Çekici Çağırın!',
        text: 'Aracınız yolda mı kaldı? Tek tıkla en yakın çekiciyi çağırın.',
        label: 'Çekici Çağır',
        href: 'https://yol-sepeti-web.vercel.app/home#cekici-step-1',
        tone: 'secondary',
      }}
    />
  );
}
